/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_Private_InstructionsInputs */

const en_vault_private_instructions = /** @type {(inputs: Vault_Private_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private Instructions & Credentials`)
};

const id_vault_private_instructions = /** @type {(inputs: Vault_Private_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruksi & Kredensial Pribadi`)
};

/** @type {(inputs: Vault_Private_InstructionsInputs) => LocalizedString} */
const es_vault_private_instructions = en_vault_private_instructions;

/** @type {(inputs: Vault_Private_InstructionsInputs) => LocalizedString} */
const fr_vault_private_instructions = en_vault_private_instructions;

/** @type {(inputs: Vault_Private_InstructionsInputs) => LocalizedString} */
const de_vault_private_instructions = en_vault_private_instructions;

/** @type {(inputs: Vault_Private_InstructionsInputs) => LocalizedString} */
const ja_vault_private_instructions = en_vault_private_instructions;

/** @type {(inputs: Vault_Private_InstructionsInputs) => LocalizedString} */
const zh_vault_private_instructions = en_vault_private_instructions;

/** @type {(inputs: Vault_Private_InstructionsInputs) => LocalizedString} */
const ar_vault_private_instructions = en_vault_private_instructions;

/** @type {(inputs: Vault_Private_InstructionsInputs) => LocalizedString} */
const it_vault_private_instructions = en_vault_private_instructions;

/** @type {(inputs: Vault_Private_InstructionsInputs) => LocalizedString} */
const ru_vault_private_instructions = en_vault_private_instructions;

/** @type {(inputs: Vault_Private_InstructionsInputs) => LocalizedString} */
const pt_vault_private_instructions = en_vault_private_instructions;

/** @type {(inputs: Vault_Private_InstructionsInputs) => LocalizedString} */
const ko_vault_private_instructions = en_vault_private_instructions;

/**
* | output |
* | --- |
* | "Private Instructions & Credentials" |
*
* @param {Vault_Private_InstructionsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_private_instructions = /** @type {((inputs?: Vault_Private_InstructionsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_Private_InstructionsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_private_instructions(inputs)
	if (locale === "es") return es_vault_private_instructions(inputs)
	if (locale === "fr") return fr_vault_private_instructions(inputs)
	if (locale === "de") return de_vault_private_instructions(inputs)
	if (locale === "ja") return ja_vault_private_instructions(inputs)
	if (locale === "zh") return zh_vault_private_instructions(inputs)
	if (locale === "ar") return ar_vault_private_instructions(inputs)
	if (locale === "id") return id_vault_private_instructions(inputs)
	if (locale === "it") return it_vault_private_instructions(inputs)
	if (locale === "ru") return ru_vault_private_instructions(inputs)
	if (locale === "pt") return pt_vault_private_instructions(inputs)
	return ko_vault_private_instructions(inputs)
});